(() => {
  const W = 400, H = 500;
  const C = { red: '#CB2026', cream: '#FFF8E9', ink: '#1C1A17', bun: '#D9933F', bunHi: '#F0BC6A', beef: '#5A321C', cheese: '#F2B632', lettuce: '#5FA83B', tomato: '#E2463A', pickle: '#7C9A2E', bottle: '#E8C547' };
  const GOOD = [
    { k: 'patty', pts: 3, h: 16, w: 0.92, p: 0.34 },
    { k: 'cheese', pts: 2, h: 8, w: 1, p: 0.22 },
    { k: 'lettuce', pts: 1, h: 9, w: 1, p: 0.14 },
    { k: 'tomato', pts: 1, h: 8, w: 0.85, p: 0.12 },
    { k: 'pickle', pts: 1, h: 7, w: 0.6, p: 0.18 }
  ];

  const soundOn = () => { try { return sessionStorage.getItem('bb_sound') === '1'; } catch (e) { return false; } };
  let ac = null;
  function beep(freq, dur = 0.08, type = 'square', vol = 0.06) {
    if (!soundOn()) return;
    try {
      ac = ac || new (window.AudioContext || window.webkitAudioContext)();
      const o = ac.createOscillator(), g = ac.createGain(), t = ac.currentTime;
      o.type = type; o.frequency.setValueAtTime(freq, t);
      g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g).connect(ac.destination); o.start(t); o.stop(t + dur + 0.02);
    } catch (e) {}
  }

  function rr(ctx, x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }

  function drawLayer(ctx, k, cx, y, w) {
    const x = cx - w / 2;
    switch (k) {
      case 'patty': ctx.fillStyle = C.beef; rr(ctx, x, y, w, 16, 8); ctx.fill(); ctx.fillStyle = 'rgba(255,255,255,.12)'; ctx.fillRect(x + 8, y + 4, w - 16, 2); break;
      case 'cheese': ctx.fillStyle = C.cheese; ctx.beginPath(); ctx.moveTo(x - 4, y); ctx.lineTo(x + w + 4, y); ctx.lineTo(x + w - 2, y + 8);
        for (let i = 1; i < 6; i++) { const px = x + w - (w / 6) * i; ctx.lineTo(px, y + (i % 2 ? 14 : 8)); }
        ctx.lineTo(x + 2, y + 8); ctx.closePath(); ctx.fill(); break;
      case 'lettuce': ctx.fillStyle = C.lettuce; ctx.beginPath(); ctx.moveTo(x - 4, y + 4);
        for (let i = 0; i <= 10; i++) { ctx.lineTo(x - 4 + ((w + 8) / 10) * i, y + (i % 2 ? 0 : 9)); }
        ctx.lineTo(x + w + 4, y + 4); ctx.closePath(); ctx.fill(); break;
      case 'tomato': ctx.fillStyle = C.tomato; rr(ctx, x, y, w / 2 - 2, 8, 4); ctx.fill(); rr(ctx, cx + 2, y, w / 2 - 2, 8, 4); ctx.fill(); break;
      case 'pickle': ctx.fillStyle = C.pickle; for (let i = 0; i < 3; i++) { ctx.beginPath(); ctx.ellipse(x + w * (0.2 + i * 0.3), y + 3.5, w * 0.13, 3.5, 0, 0, Math.PI * 2); ctx.fill(); } break;
      case 'topbun': ctx.fillStyle = C.bun; ctx.beginPath(); ctx.moveTo(x, y + 28); ctx.quadraticCurveTo(x, y, cx, y); ctx.quadraticCurveTo(x + w, y, x + w, y + 28); ctx.closePath(); ctx.fill();
        ctx.fillStyle = C.cream; [[-.25, .45], [0, .3], [.22, .5], [-.05, .6], [.32, .7]].forEach(([dx, dy]) => { ctx.beginPath(); ctx.ellipse(cx + dx * w, y + dy * 28, 3, 1.8, 0.3, 0, Math.PI * 2); ctx.fill(); }); break;
    }
  }

  function drawBottle(ctx, cx, y) {
    ctx.fillStyle = C.bottle; rr(ctx, cx - 12, y + 10, 24, 34, 6); ctx.fill();
    ctx.fillRect(cx - 5, y, 10, 12); ctx.fillStyle = C.red; ctx.fillRect(cx - 6, y - 4, 12, 6);
    ctx.fillStyle = C.cream; ctx.fillRect(cx - 10, y + 20, 20, 13);
    ctx.fillStyle = C.ink; ctx.font = '800 6px Archivo, sans-serif'; ctx.textAlign = 'center'; ctx.fillText('SEED', cx, y + 26); ctx.fillText('OIL', cx, y + 32);
    ctx.strokeStyle = C.red; ctx.lineWidth = 3; ctx.beginPath(); ctx.arc(cx, y + 24, 19, 0, Math.PI * 2); ctx.moveTo(cx - 13, y + 11); ctx.lineTo(cx + 13, y + 37); ctx.stroke();
  }

  function init(stage) {
    if (stage.dataset.ready) return; stage.dataset.ready = '1';
    const sec = stage.closest('.catch');
    const canvas = stage.querySelector('canvas'), ctx = canvas.getContext('2d');
    const $ = (s) => stage.querySelector(s);
    const elScore = $('[data-catch-score]'), elTime = $('[data-catch-time]'), elLives = $('[data-catch-lives]');
    const startScr = $('[data-catch-start]'), endScr = $('[data-catch-end]');
    const elFinal = $('[data-catch-final]'), elRank = $('[data-catch-rank]'), elBest = sec.querySelector('[data-catch-best]');
    const ranks = (stage.dataset.ranks || '').split('|');
    const SECONDS = parseInt(stage.dataset.seconds, 10) || 30;
    const BEST_KEY = 'bb_catch_best';
    let best = 0; try { best = parseInt(localStorage.getItem(BEST_KEY), 10) || 0; } catch (e) {}
    elBest.textContent = best;

    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    let state = 'idle', items = [], stack = [], px = W / 2, target = W / 2, score = 0, lives = 3, timeLeft = SECONDS, spawnT = 0, last = 0, elapsed = 0, flash = 0, pops = [];
    const BUN_W = 96, BASE_Y = H - 46, LAYER_MAX = 16;

    const stackTop = () => BASE_Y - stack.slice(-LAYER_MAX).reduce((s, l) => s + l.h - 2, 0);
    const pickGood = () => { let r = Math.random(), a = 0; for (const g of GOOD) { a += g.p; if (r <= a) return g; } return GOOD[0]; };

    function spawn() {
      const bad = Math.random() < Math.min(0.18 + elapsed * 0.006, 0.34);
      const speed = 120 + elapsed * 6 + Math.random() * 60;
      items.push(bad ? { bad: true, x: 30 + Math.random() * (W - 60), y: -50, v: speed * 1.1, r: (Math.random() - .5) * 2 }
                     : { g: pickGood(), x: 40 + Math.random() * (W - 80), y: -20, v: speed, r: 0 });
    }

    function hud() { elScore.textContent = score; elTime.textContent = Math.ceil(timeLeft); elLives.textContent = '♥'.repeat(Math.max(lives, 0)) + '♡'.repeat(Math.max(3 - lives, 0)); }

    function start() {
      items = []; stack = []; pops = []; score = 0; lives = 3; timeLeft = SECONDS; spawnT = 0; elapsed = 0; px = target = W / 2; flash = 0;
      startScr.hidden = true; endScr.hidden = true; state = 'play'; last = performance.now(); hud(); beep(660, .1);
      canvas.focus({ preventScroll: true });
      requestAnimationFrame(loop);
    }

    function end() {
      state = 'over';
      stack.push({ k: 'topbun', h: 30, w: 1 });
      draw();
      if (score > best) { best = score; try { localStorage.setItem(BEST_KEY, String(best)); } catch (e) {} elBest.textContent = best; }
      elFinal.textContent = 'Rp ' + (score * 1000000).toLocaleString('id-ID');
      elRank.textContent = score < 15 ? ranks[0] : score < 35 ? ranks[1] : score < 60 ? ranks[2] : ranks[3];
      setTimeout(() => { endScr.hidden = false; endScr.querySelector('[data-catch-play]').focus({ preventScroll: true }); }, 600);
      beep(330, .25, 'triangle'); setTimeout(() => beep(523, .3, 'triangle'), 180);
    }

    function loop(t) {
      if (state !== 'play') return;
      const dt = Math.min((t - last) / 1000, 0.05); last = t;
      if (document.hidden) { requestAnimationFrame(loop); return; }
      elapsed += dt; timeLeft -= dt;
      px += (target - px) * Math.min(dt * 14, 1);
      spawnT -= dt; if (spawnT <= 0) { spawn(); spawnT = Math.max(0.32, 0.8 - elapsed * 0.012); }
      const top = stackTop();
      for (const it of items) {
        it.y += it.v * dt; it.rot = (it.rot || 0) + it.r * dt;
        const catchY = it.bad ? it.y + 44 : it.y + 10;
        if (!it.done && catchY >= top - 4 && catchY <= top + 18 && Math.abs(it.x - px) < BUN_W / 2 + (it.bad ? 4 : 10)) {
          it.done = true;
          if (it.bad) { lives--; flash = 0.35; stack.splice(-2, 2); beep(140, .25, 'sawtooth', .08); if (navigator.vibrate) navigator.vibrate(60); pops.push({ x: px, y: top - 20, txt: '-1 ♥', c: C.red, t: 1 }); }
          else { stack.push({ k: it.g.k, h: it.g.h, w: it.g.w }); score += it.g.pts; beep(500 + Math.min(stack.length, 20) * 25, .06); pops.push({ x: px, y: top - 20, txt: '+' + it.g.pts, c: C.ink, t: 1 }); }
        }
      }
      items = items.filter((it) => !it.done && it.y < H + 60);
      pops.forEach((p) => { p.t -= dt * 1.5; p.y -= dt * 40; }); pops = pops.filter((p) => p.t > 0);
      flash = Math.max(0, flash - dt);
      hud(); draw();
      if (timeLeft <= 0 || lives <= 0) { timeLeft = Math.max(timeLeft, 0); hud(); end(); return; }
      requestAnimationFrame(loop);
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = C.cream; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = 'rgba(203,32,38,.06)'; for (let y = 0; y < H; y += 40) for (let x = (y / 40) % 2 ? 20 : 0; x < W; x += 40) ctx.fillRect(x, y, 20, 20);
      ctx.fillStyle = C.ink; ctx.fillRect(0, H - 14, W, 14);
      // plate
      ctx.fillStyle = '#E9DFCB'; ctx.beginPath(); ctx.ellipse(px, BASE_Y + 22, BUN_W * 0.75, 8, 0, 0, Math.PI * 2); ctx.fill();
      // bottom bun
      ctx.fillStyle = C.bun; rr(ctx, px - BUN_W / 2, BASE_Y, BUN_W, 20, 9); ctx.fill(); ctx.fillStyle = C.bunHi; ctx.fillRect(px - BUN_W / 2 + 6, BASE_Y + 2, BUN_W - 12, 3);
      // stack
      let y = BASE_Y; const vis = stack.slice(-LAYER_MAX);
      for (const l of vis) { y -= l.h - 2; drawLayer(ctx, l.k, px, y, BUN_W * l.w); }
      // falling
      for (const it of items) {
        if (it.bad) { ctx.save(); ctx.translate(it.x, it.y + 22); ctx.rotate(it.rot || 0); drawBottle(ctx, 0, -22); ctx.restore(); }
        else drawLayer(ctx, it.g.k, it.x, it.y, 60 * it.g.w);
      }
      ctx.font = '800 16px Archivo, sans-serif'; ctx.textAlign = 'center';
      for (const p of pops) { ctx.globalAlpha = Math.max(p.t, 0); ctx.fillStyle = p.c; ctx.fillText(p.txt, p.x, p.y); }
      ctx.globalAlpha = 1;
      if (flash > 0) { ctx.fillStyle = `rgba(203,32,38,${flash})`; ctx.fillRect(0, 0, W, H); }
    }

    // Controls
    const toX = (clientX) => { const r = canvas.getBoundingClientRect(); return Math.max(BUN_W / 2, Math.min(W - BUN_W / 2, ((clientX - r.left) / r.width) * W)); };
    canvas.addEventListener('pointerdown', (e) => { target = toX(e.clientX); canvas.setPointerCapture(e.pointerId); });
    canvas.addEventListener('pointermove', (e) => { if (state === 'play' && (e.pointerType === 'mouse' || e.buttons)) target = toX(e.clientX); });
    canvas.tabIndex = 0;
    canvas.addEventListener('keydown', (e) => {
      if (state !== 'play') return;
      if (e.key === 'ArrowLeft' || e.key === 'a') { target = Math.max(BUN_W / 2, target - 40); e.preventDefault(); }
      if (e.key === 'ArrowRight' || e.key === 'd') { target = Math.min(W - BUN_W / 2, target + 40); e.preventDefault(); }
    });
    stage.querySelectorAll('[data-catch-play]').forEach((b) => b.addEventListener('click', start));
    draw();
  }

  const boot = (root = document) => root.querySelectorAll('[data-catch]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
